import { type Enum } from '@webapp/utils'

export const PayCardTypes = {
  PHYSICAL: 0,
  VIRTUAL: 1,
} as const
export type PayCardType = Enum<typeof PayCardTypes>
